import React from "react";
import { useDotLegalSnackbar } from "@dotlegal/dotlegal-ui-components";
import { put } from "../../../common/api/apiShared.ts";
import { useDotLegalMutation } from "@common/hooks/dotLegalReactQuery";
import { useTranslation } from "../../../localization/useTranslation.ts";
import { SystemModel } from "../../../system/systemEdit/SystemEdit.types.ts";
import ExcludedUsersField from "../ExcludedUsersField.tsx";
import { useNavigate } from "react-router";
import { useUrlProvider } from "../../../useUrlProvider.ts";

export interface SystemExcludedUsersFieldProps {
    systemId: string;
    system: SystemModel | undefined;
    isLoading: boolean;
    onChange: (changeFunc: (system: SystemModel) => void) => Promise<void>;
    readOnly?: boolean;
    disabled: boolean;
    isPreview: boolean;
    errorText?: string;
    toolTipText?: string;
    warningText?: string;
}

function SystemExcludedUsersField(props: SystemExcludedUsersFieldProps) {
    const snackbar = useDotLegalSnackbar();
    const { translateString } = useTranslation();
    const navigate = useNavigate();
    const urlProvider = useUrlProvider();

    const removeFromExcludedMutation = useDotLegalMutation((userId: string) => put(`/system-user-access/${props.systemId}/remove-excluded/${userId}`, null));

    async function onRemoveFromExcluded(userId: string) {
        await removeFromExcludedMutation.mutateAsync(userId, {
            onSuccess: () => {
                snackbar.show(translateString("removedFromExcluded"));
            },
        });
    }

    return (
        <ExcludedUsersField
            entity={props.system}
            isLoading={props.isLoading}
            onChange={props.onChange}
            onConfirmNavigate={() => navigate(urlProvider.getSystemsUrl())}
            onRemoveFromExcluded={onRemoveFromExcluded}
            removeFromExcludedInProgress={removeFromExcludedMutation.isLoading}
            readOnly={props.readOnly}
            disabled={props.disabled}
            isPreview={props.isPreview}
            errorText={props.errorText}
            toolTipText={props.toolTipText}
            warningText={props.warningText}
        />
    );
}

export default SystemExcludedUsersField;
